import * as types from './types';

/**
 * ---------------------------------------------------
 *  CATEGORIAS DA INSTITUIÇÃO
 * ---------------------------------------------------
 */
export function listCategoriesRequest(payload) {
  return {
    type: types.LIST_CATEGORIES_REQUEST,
    payload,
  };
}

export function listCategoriesSuccess(payload) {
  return {
    type: types.LIST_CATEGORIES_SUCCESS,
    payload,
  };
}

export function listCategoriesFailure(payload) {
  return {
    type: types.LIST_CATEGORIES_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 *  CADASTRO DE INSTITUIÇÃO
 * ---------------------------------------------------
 */

export function newInstitutionRequest(payload) {
  return {
    type: types.NEW_INSTITUTION_REQUEST,
    payload,
  };
}

export function newInstitutionSuccess(payload) {
  return {
    type: types.NEW_INSTITUTION_SUCCESS,
    payload,
  };
}

export function newInstitutionFailure(payload) {
  return {
    type: types.NEW_INSTITUTION_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 *  LOGO DA INSTITUIÇÃO
 * ---------------------------------------------------
 */

export function uploadLogoRequest(payload) {
  return {
    type: types.LOGO_INSTITUTION_REQUEST,
    payload,
  };
}

export function uploadLogoSuccess(payload) {
  return {
    type: types.LOGO_INSTITUTION_SUCCESS,
    payload,
  };
}

export function uploadLogoFailure(payload) {
  return {
    type: types.LOGO_INSTITUTION_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 *  GET INSTITUIÇÃO
 * ---------------------------------------------------
 */

export function getInstitutionRequest(payload) {
  return {
    type: types.GET_INSTITUTION_REQUEST,
    payload,
  };
}

export function getInstitutionSuccess(payload) {
  return {
    type: types.GET_INSTITUTION_SUCCESS,
    payload,
  };
}

export function getInstitutionFailure(payload) {
  return {
    type: types.GET_INSTITUTION_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 *  GET INSTITUIÇÕES PARTICIPANTES
 * ---------------------------------------------------
 */

export function getInstitutionsRequest(payload) {
  return {
    type: types.GET_INSTITUTIONS_REQUEST,
    payload,
  };
}

export function getInstitutionsSuccess(payload) {
  return {
    type: types.GET_INSTITUTIONS_SUCCESS,
    payload,
  };
}

export function getInstitutionsFailure(payload) {
  return {
    type: types.GET_INSTITUTIONS_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 *  OPCOES PERFIL HOSPITALAR
 * ---------------------------------------------------
 */

export function opcoesPerfilSuccess(payload) {
  return {
    type: types.OPCOES_PERFIL_SUCCESS,
    payload,
  };
}

export function opcoesPerfilFailure() {
  return {
    type: types.OPCOES_PERFIL_FAILURE,
  };
}
